<template>
  <v-checkbox
    v-model="checked"
    class="MatchBucket"
    :color="checkboxColor"
    hide-details
  >
    <template #label>
      <v-div d-inline body-1 :foreground="labelColor">
        <span>{{ bucket.label }}</span>
        <v-div
          v-if="bucket.count"
          d-inline
          caption
          font-small
          foreground-muted
          ml-1
          >({{ bucket.count }})</v-div
        >
      </v-div>
    </template>
  </v-checkbox>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "MatchBucket",
  props: {
    bucket: { type: Object, required: true },
    selected: { type: Array, default: () => [] },
  },
  computed: {
    ...mapState({
      layout: (state) => state.theme.layout,
    }),
    labelColor() {
      return this.layout.matchBucketLabelColor;
    },
    checkboxColor() {
      return this.layout.matchBucketCheckboxColor;
    },
    checked: {
      get() {
        const match = this.bucket.key;
        const list = this.selected;
        const matched = list.find((id) => id === match);
        const checked = matched !== undefined;

        return this.bucket.checked || checked;
      },
      set(newValue) {
        this.$emit("selectionChanged", {
          id: this.bucket.key,
          value: newValue,
        });
      },
    },
  },
};
</script>
